import HtmlTooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import format from "date-fns/format";
import React, { useState } from "react";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineTicket, HiQrcode } from "react-icons/hi";
import { Ticket } from "../../../models/Ticket";
import "./limitedMobile.scss";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { MdEventAvailable } from "react-icons/md";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import { useTranslation } from "react-i18next";

interface IProps {
  ticket: Ticket;
}
const LimitedTicketMobile: React.FC<IProps> = ({ ticket }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <React.Fragment>
      <div className="limited-ticket-mobile">
        <div className="limited-ticket-mobile-title flex-start-center">
          <HiOutlineTicket className="big-icon" />
          <h4>{ticket.name}</h4>
        </div>

        <div className="limited-ticket-mobile-line"></div>

        <div className="limited-ticket-body">
          <div className="flex-start-center">
            <MdEventAvailable className="icon" />
            <b>
              {t("wazny_od")}: {format(ticket.validfrom, `dd.MM.yyyy`)}r.
            </b>
          </div>

          <div className="flex-start-center">
            <MdEventAvailable className="icon" />
            <b>
              {t("wazny_do")}: {format(ticket.validto, `dd.MM.yyyy`)}r.
            </b>
          </div>
        </div>

        <div onClick={() => setOpen(!open)} className="limited-ticket-buttons">
          <button className="button medium padding-medium full-button button-fill-main">{t("pokaz_kod_qr")}</button>
        </div>
      </div>

      {open && (
        <ModalComponent
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <button
            onClick={() => setOpen(!open)}
            className="button big padding-medium button-fill-second  center-button"
          >
            {t("gotowe_schowaj")}
          </button>
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default LimitedTicketMobile;
